module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "Chapter-number ParaOverride-6"
  }, [_c('span', {
    staticClass: "Chapter-number _idGenCharOverride-4"
  }, [_vm._v("Chapter")]), _c('span', {
    staticClass: "CharOverride-19"
  }, [_vm._v(" One")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-title-one-line"
  }, [_c('span', {
    staticClass: "Chap-title _idGenCharOverride-1"
  }, [_vm._v("Are American Workers Different?")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-4"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("n 1886, the first May Day of the world working-­class movement was marked in the United States by a massive political strike wave of more than three hundred thousand workers—forty thousand in Chicago alone—demanding the eight-­hour day. The anarchist-­led Chicago Labor Union, called “upon all wage workers the necessity of procuring arms before the inauguration of the proposed eight-­hour strike, in order to be in a position ")]), _c('span', {
    staticClass: "text-body-drop-cap _idGenCharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" meeting our foe with his own argument, force.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-1",
      "id": "Txt-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" During this tumultuous period, newspaper headlines nationwide expressed the alarm of business leaders, asking, “The Revolution?")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-2",
      "id": "Txt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" The struggle culminated in a police massacre in ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Chicago’s Haymarket Square, and the trial and execution of four of the movement’s leaders, including August Spies and Albert Parsons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("The scope and violence of the 1886 strike wave convinced Karl ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Marx’s collaborator Frederick Engels that class consciousness was rising on a mass scale amid rapid industrialization. As he wrote to Florence Kelley Wischnewetsky, “the American working class is moving, and no mistake. And after a few false starts, they will get into the right track soon enough. This appearance of the Americans upon the scene I consider one of the greatest events of the year.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-3",
      "id": "Txt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" To be sure, Engels recognized that the road to an independent workers’ party would not be a smooth one. In 1893, Engels wrote, in a letter to German socialist Adolph Sorge, “[I]t cannot be denied that American conditions involve very great and peculiar difficulties for a steady development of a workers’ party.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-4",
      "id": "Txt-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" But Engels remained optimistic until the end of his life that workers in the United States would, as elsewhere, eventually form an independent political party.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("More than a century later, however, workers in the U.S. still have no political party independent of the corporate-­backed Democrats and Republicans. In this important way, the U.S. working class ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("hasn’t followed the same path as workers’ movements in most other industrialized countries, which have developed and sustained labor or social democratic parties. At the same time, U.S. workers have historically shown an enormous capacity to battle their employers. The labor movement’s formative period, in the fifty years after the Civil War, took place amid sharp economic booms and slumps matched by dramatic ups and downs in class struggle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Between 1881 (the first year for which reliable figures are available) and 1905, 7.5 million workers took part in a total of 38,303 strikes across the United States. In that same time period, 198 strikers or sympathizers were killed, 1,966 were wounded, and 6,114 arrested.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-5",
      "id": "Txt-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" For more than a century, the class struggle in the United States fit a pattern of (sometimes long) periods of calm, punctuated by huge explosions of struggle. Most often those periods of calm, far from representing class harmony, witnessed dramatic setbacks for the labor movement. Then years of pent-­up bitterness and class anger gave way to massive eruptions of struggle, in an American parallel to British historian E. J. Hobsbawm’s apt description of “collective bargaining by riot.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-6",
      "id": "Txt-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Historian Jeremy Brecher described the Southwestern Railroad strike in 1886: “The characteristic response of the workers to [management’s] attempts to break the strike was the ‘killing’ of the engines. This was done by putting out the ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("engine’s fire, letting out "), _c('br'), _vm._v("the water, displacing engine connections, and destroying part of the machinery.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-7",
      "id": "Txt-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" The Russian revolutionary Leon Trotsky noted the "), _c('br'), _vm._v("extraordinary militancy of U.S. workers in his 1934 article, “If America Should Go Communist”:")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent-first-para"
  }, [_c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v("The American temperament is energetic and violent, and it will insist on breaking a good many dishes and upsetting a good many apple carts before Communism is firmly established. Americans are enthusiasts and sportsmen before they are specialists and statesmen, and it would be contrary to the American tradition to make a major change without choosing sides and cracking heads.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-8",
      "id": "Txt-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("But American workers’ breathtaking combativeness has coexisted alongside a weak political tradition. Although the Chicago Haymarket massacre helped to establish May Day as a holiday for workers worldwide, this holiday is still not celebrated in the United States. Indeed, many active unionists have never heard of May Day nor are they aware of its origins in American workers’ struggle for the eight-­hour day. Likewise, the 1909 New York City garment workers’ strike inspired another socialist holiday, International ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Women’s Day—celebrated on March 8 each year around the world.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-9",
      "id": "Txt-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" But like May Day, International ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Women’s Day remains part of the hidden history of the labor movement, unknown to the vast majority of American workers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Level-1-head"
  }, [_c('span', {
    staticClass: "Subhead CharOverride-20"
  }, [_vm._v("The Myth of “American Exceptionalism” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-after-subhead ParaOverride-4"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("U.S. employers have always been keenly aware that the promise of prosperity could be a useful weapon in the class struggle—a corresponding carrot to the stick of repression they so often wielded. As Julius Rosenwald, founder of the Shefferman union-­busting firm, remarked in 1926, ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("“Don’t imagine, however, that anything we do for our people in the way of profit sharing, or enabling them to acquire stock, or providing meals at low rates, medical attention, recreation grounds, vacations, and so forth is done from philanthropic motives—not in the least. Whatever we do for our employees we do because we think it pays, because it is good business.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-10",
      "id": "Txt-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Yet a range of theories have long asserted that the promise of upward mobility has rendered the American working class uniquely incapable of sustaining class consciousness, much less a class-­wide movement for socialism. Broadly grouped, these theories fall into the category of what has become known as “American exceptionalism.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Theories of American exceptionalism have been around since the days when immigrants were first lured to America with tales that the streets were paved with gold and claims that anyone could strike it rich in the “land of opportunity.” In 1831, French historian and sociologist Alexis de Tocqueville marveled at the “democracy” he found in the U.S., especially as compared to the continued existence of a landed nobility throughout Europe. “The position of the Americans is quite exceptional,” he commented, “and it may be believed that no democratic people will ever be placed in a similar one.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-11",
      "id": "Txt-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" De Tocqueville’s enthusiastic comments are often cited by proponents of American exceptionalism.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("De Tocqueville’s enthusiasm, however, was tempered by the gaping class inequality he also observed in the United States, where there are “some men who are very opulent and a multitude who are wretchedly poor.” De Tocqueville expressed reservations that ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("America’s “manufacturing aristocracy which is growing up under our eyes is one of the harshest that ever existed in the world.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-12",
      "id": "Txt-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Those seeking to prove that American society has success-"), _c('br'), _vm._v("fully contained working-­class consciousness rarely acknowledge "), _c('br'), _vm._v("de Tocqueville’s lack of enthusiasm for the rising manufacturing class.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-13",
      "id": "Txt-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Yet this offers insight into the limits of “democracy” and class mobility in U.S. society, even in the early nineteenth century.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("As editors Rick Halpern and Jonathan Morris argued in ")]), _c('span', {
    staticClass: "Text-body CharOverride-12"
  }, [_vm._v("American Exceptionalism? U.S. Working-­Class Formation in an International Context,")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" the approach guiding most theories of American exceptionalism is problematic because “absence rather than presence is seen to hold the key to American distinctiveness.” As they explain,")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent-one-para"
  }, [_c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v("The lack of a sufficient degree of “class consciousness,” characterized by the failure to establish a labour party, renders intelligible both the relative weakness of early twentieth-­century trade unionism in the U.S. as well as the uncontested dominance of the two major parties. Of course, this framework precludes all sorts of interesting and important investigations into actual working-­class politics, radicalism, organization, and activity. .")]), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v(". If the proponents of exceptionalism found no evidence of class conflict, then the labour historians would uncover a history of struggle that rivaled that of any European proletariat.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-14",
      "id": "Txt-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Indeed, the massive struggles that shook U.S. society in the latter half of the nineteenth century exposed the brutal underbelly of ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("America’s “unique” democracy and the explosive nature of class conflict. As historian Neville Kirk argues, “The immediate post-­bellum years [following the Civil War] in the North saw a revived labour movement commit itself to the principle of independent labour politics. In the South, the desires of free Black people .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". for control over their labour and ownership of land flatly contradicted bourgeois expectations that freedom for Black people would equal the freedom to earn a wage and sell their labour power to capitalist employers.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-15",
      "id": "Txt-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" The violent battles of this period, Kirk writes, showed “the far less consensual, neutral and pluralistic sides of the American liberal state and ruling bloc: capital accumulation and the employer’s ‘right’ to absolute mastery in the workplace were to be guaranteed at all costs.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-16",
      "id": "Txt-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Some exceptionalism themes nevertheless deserve consideration and can aid in understanding the character of class consciousness during the labor movement’s formative years.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-17",
      "id": "Txt-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("First, as de Tocqueville argued, the character of American society was different than that found in Europe because the United States had no feudal past, and therefore no landed aristocracy. In contrast to the development of European bourgeois democracy, the American Revolution granted universal suffrage (for white males) from the outset. All women were denied the vote, and ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("America’s Black population lacked any rights of citizenship, but U.S. workers had no "), _c('br'), _vm._v("immediate class-­wide impetus to form independent workers’ movements to struggle for democratic rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Second, upward class mobility was a possibility for a significant minority of workers. U.S. industry expanded rapidly in the decades following the Civil War. In 1860, American iron and steel production amounted to one-­fifth of British output. By the turn of the century, the United States was the largest steel manufacturer in the world.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-18",
      "id": "Txt-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Despite brutal working conditions, workers could aspire toward management and even entrepreneurial pursuits. In addition, the U.S. government opened the door to massive Western migration after the Civil War by granting ownership to anyone who settled on land owned by the government. Migration to the Western frontier contributed to a turnover among workers who might otherwise have stayed and fought for better conditions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Third, immigrants made up a sizeable proportion of the U.S. working class, and they were separated by language and cultural differences in an already racially and ethnically divided society. Moreover, many immigrants were only a “temporary proletariat,” who could move to the West, aspire to rise up the social ladder, or return home. Thus immigrants alone could not constitute the basis for the development of a permanent working-­class movement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Taken as a whole, the themes described above can help to explain why a substantial layer of workers would seek individual, rather than collective, solutions during the second half of the nineteenth century. But the importance of these factors should not be exaggerated. These theories describe temporary, not permanent, features of American society. These factors made it more difficult for U.S. workers to develop class-­wide organizations, but only until the first decades of the twentieth century. By 1886, Engels already foresaw these factors fading as obstacles to class-­wide consciousness:")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent-first-para ParaOverride-13"
  }, [_c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v("There were two circumstances which for a long time prevented the unavoidable consequences of the Capitalist system from showing themselves in the full glare of day in America. These were the easy access to the ownership of cheap land and the influx of immigration. They allowed, for many years, the great mass of the native American population to “retire” in early manhood from wage-­labour and to become farmers, dealers, or employers of labour, while the hard work for wages, the position of a proletarian for life, mostly fell to the lot of immigrants. But America has outgrown this early stage. The boundless backwoods have disappeared, and the still more boundless prairies are faster and faster passing from the hands of the Nation and the States into those of private owners. The great safety-­valve against the formation of a permanent proletarian class has practically ceased to act. A class of life-­long and even hereditary proletarians exists at this hour in America.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-19",
      "id": "Txt-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("By the dawn of the twentieth century, no Western frontier remained to be conquered. And though U.S. capitalism continued to expand in the twentieth century, employers turned toward raising the productivity of labor rather than relying on an ever-­growing labor force. By the 1920s, immigration was severely curbed for several decades, and upward mobility ceased to be a possibility for the vast majority of workers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("If the potential to develop mass working-­class organization ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("hadn’t existed in the nineteenth century, it certainly did by the twentieth. As British socialist Duncan Hallas argued, “All the special factors which can be shown to have operated in the United States until 1900 or 1920 were now of steadily diminishing importance. So the presence or absence of a political labour movement has to be judged in terms of certain specific events and struggles.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-20",
      "id": "Txt-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "Level-2-subhead ParaOverride-14"
  }, [_c('span', {
    staticClass: "Subhead-2 _idGenCharOverride-1"
  }, [_vm._v("Prosperity and Class Consciousness")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-after-subhead ParaOverride-4"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("The most persistent claim of exceptionalism theorists, however, is that prosperity alone has permanently thwarted class consciousness in the United States. The most influential proponents of this claim have not been the gleeful defenders of the class status quo, but most often academic “experts” in the field of sociology.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("As early as 1906, sociologist Warner Sombart had already declared that the U.S. working class was too enamored by capitalism to build a socialist movement. In his book, ")]), _c('span', {
    staticClass: "Text-body CharOverride-12"
  }, [_vm._v("Why Is There No Socialism in the United States?")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Sombart asserted that the United States was “the promised land of capitalism” where “on the reefs of roast beef and apple pie socialistic Utopias .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". are sent to their doom.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-21",
      "id": "Txt-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Sombart drew this conclusion at a time when millions of workers crowding city slums and shantytowns across the United States rarely got a decent meal, and class war had long been raging in the “land of opportunity.” Indeed, in 1903, David M. Parry, president of the National Association of Manufacturers (NAM), railed against “the present program of violence, boycotting, and tyranny now being carried out by the majority of labor unions,” as he called for combating “legislation of a socialistic nature.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-22",
      "id": "Txt-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Moreover, while average wages were higher in the United States than in Europe, the gap between the wages of skilled and unskilled workers was greater.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-23",
      "id": "Txt-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Theories of American exceptionalism became popular once again during the long economic boom following World War II, when more than two decades of unprecedented prosperity temporarily blunted working-­class consciousness in the shadow of the “American Dream.” Sociologist Daniel Bell famously proclaimed “the end of ideology” in 1960, adding later, “Abundance .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". was the American surrogate for socialism.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-24",
      "id": "Txt-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" In 1973, sociologist Benjamin S. Kleinberg argued that American workers’ interests coincided with those of American capitalism: [R]esolving the tensions between different social classes requires no fundamental redistribution of the social product, only its continued growth. Growth of the national product is viewed as a good in itself. .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". To the extent that individuals can satisfy their desires for a material improvement of living standards, they lose interest in ideology and even in politics itself.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-25",
      "id": "Txt-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Decades of falling wages and living standards since Kleinberg made this statement have exposed the shortsightedness of this view. “Four out of five households take home a thinner slice of the economic pie than they did a quarter century before,” labor historian Lichtenstein noted in 2002. Today, CEOs earn more than a thousand times the average ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("worker’s wage.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-26",
      "id": "Txt-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Young male workers have experienced the steepest decline in real wages—25 percent between the early 1970s and the early 1990s.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-27",
      "id": "Txt-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("American exceptionalism nevertheless experienced a reincarnation during the 1990s, albeit on shakier grounds. As Halpern and Morris commented, “Books and articles dealing with exceptionalism form a small growth industry in academic publishing on both sides of the Atlantic.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-28",
      "id": "Txt-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Political analyst Seymour Martin ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Lipset’s particular variation on American exceptionalism rests not on promises of prosperity, but on ideology alone. In his 1997 book, ")]), _c('span', {
    staticClass: "Text-body CharOverride-12"
  }, [_vm._v("American Exceptionalism: A Double-­Edged Sword,")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Lipset acknowledges,")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent-one-para ParaOverride-15"
  }, [_c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v("The United States continues to be exceptional among developed nations in the low level of support it provides for the poor through welfare, housing, and medical care policies. As a result, though the wealthiest country, it has the highest proportion of people living in poverty among developed nations, according to the detailed statistical analyses of the Luxembourg Income Study data, the most comprehensive available. The United States also ranks last among ten countries (six in Europe, plus Australia, Canada, and Israel) as the most unequal in comparisons of income distribution.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-29",
      "id": "Txt-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Lipset further admits that Americans have grown increasingly distrustful of political leaders and institutions for the last three decades. “This erosion of trust in American government is troubling,” he writes. But U.S. society is permanently cushioned from the threat of a left-­wing revolt, Lipset argues, due to popular acceptance of a unique set of “American values,” including a strong sense of morality and an American work ethic that ensures “the survival of the American Dream.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-30",
      "id": "Txt-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Traditional theories of American exceptionalism would be easy to dismiss as either obsolete or unproven. But left academics often echo the same arguments as their more mainstream counterparts, particularly during longer periods of labor calm. More than one "), _c('br'), _vm._v("left-­wing writer has dismissed the potential for mass working-­class struggle—only to be proven wrong by the next labor upsurge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Level-2-subhead"
  }, [_c('span', {
    staticClass: "Subhead-2 _idGenCharOverride-1"
  }, [_vm._v("Are American Workers “Bought Off”?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-indent"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("During the 1960s in particular, many leftists regarded the working class living in the heart of U.S. imperialism as part of the problem, rather than as a potentially powerful part of the struggle against capitalism and the war in Vietnam. A host of left-­wing theorists argued that the promise of owning a house in the suburbs and a color TV had permanently diverted the class interests of U.S. workers. In 1967, the German-­American philosopher Herbert Marcuse, a guru of the 1960s counter­culture, argued that the system provided a “comfortable, smooth, reasonable, democratic unfreedom. .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". Under the conditions of a rising standard of living, non-conformity with the system itself appears to be socially useless.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-31",
      "id": "Txt-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Marcuse’s observation was proven wrong by the end of the 1960s by a series of working-­class revolts and the rise of a working-­class majority opposed to the war in Vietnam. The number of unauthorized strikes across all industries doubled between 1960 and 1969, from 1,000 to 2,000. The year 1970 witnessed a veritable strike wave—including a 67-­day strike against General Motors—which was part of a rise in class struggle that subsided only in 1974.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-32",
      "id": "Txt-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Some of these struggles were political as well as economic. In 1969, 95 percent of West Virginia’s coal miners went out on a wildcat strike demanding government legislation covering Black Lung, a disease that kills so many miners. Other struggles were led by groups of workers influenced by the antiwar and Black Power movements. The most significant of these struggles led to the formation of the Dodge Revolutionary Union Movement (DRUM) in 1968. After shutting down production at the Dodge Main assembly plant in a wildcat strike, Black workers formed DRUM to combat both company and union racism.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-33",
      "id": "Txt-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Many of the strikes during this period involved some of the most highly paid workers in the U.S.—including autoworkers and Teamsters. Theorists like Marcuse, who had dismissed these workers as overpaid and part of the bulwark of the system, were proved wrong. The labor upsurge between 1967 and 1974 validated once more the historic role of the working class in Marxist theory.")])]), _vm._v(" "), _c('p', {
    staticClass: "Level-2-subhead"
  }, [_c('span', {
    staticClass: "Subhead-2 _idGenCharOverride-1"
  }, [_vm._v("Exploitation and Class Struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-indent"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Karl Marx understood the revolutionary potential of the working class as an objective consequence of exploitation. The Marxist definition of the working class, therefore, has little in common with those of sociologists. Although income levels obviously bear some relationship to class, neither income level nor degree of class consciousness determines social class. Some workers earn the same as or more than some people who fall into the category of middle class. And many people who consider themselves “middle class” are in fact workers. Nor is class defined by categories such as “blue collar” versus “white collar.” For Marxists, the working class is defined by its relationship to production. Broadly speaking, workers are those who do not control production but rather are controlled from above, and are forced to sell their labor power to employers. This definition includes the vast majority of employees in the United States.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Exploitation reduces individual workers to mere cogs in the wheels of mass production, thus depriving, or alienating, workers from the fruits of their labor. As Marx wrote in ")]), _c('span', {
    staticClass: "Text-body CharOverride-12"
  }, [_vm._v("Capital,")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" “All means for the development of production transform themselves into means of domination over, and exploitation of, the producers; they mutilate the laborer into a fragment of a man, degrade him to the level of an appendage of a machine, destroy every remnant of charm in his work and turn it into a hated toil.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-34",
      "id": "Txt-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Elsewhere in ")]), _c('span', {
    staticClass: "Text-body CharOverride-12"
  }, [_vm._v("Capital,")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" Marx added, “It follows therefore, that in proportion as capital accumulates, the lot of the laborer, be his payment high or low, must grow worse.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-35",
      "id": "Txt-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("“Scientific management” techniques were first championed by corporate consultant Frederick Winslow Taylor in the early twentieth century and have been steadily refined ever since. But ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Taylor’s operating principles—tightly timed production quotas and a strict division of labor—have been universally adopted by mass production industries, robbing workers of any control over the production process. Today, for example, workers at the Toyota NUMMI plant in California are in “motion” on the assembly line for 57 seconds out of every minute.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-36",
      "id": "Txt-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("In the 1960s, American workers were the highest paid in the world, but they paid a steep price through a drastic rise in their rate of exploitation. Output per worker more than doubled between 1947 and 1972. While the number of manufacturing workers grew by 28.8 percent between 1950 and 1968, manufacturing output grew by 91 percent. In 1950, U.S. steel mills produced half the ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("world’s steel; U.S. auto companies were responsible for 76 percent of world vehicle production.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-37",
      "id": "Txt-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" The real beneficiaries sat on the boards of directors of the biggest U.S. corporations.")])]), _vm._v(" "), _c('p', {
    staticClass: "Level-2-subhead"
  }, [_c('span', {
    staticClass: "Subhead-2 _idGenCharOverride-1"
  }, [_vm._v("The Labor Upsurge of 1967–74")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-indent"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("In 1972, eight thousand workers voted by a margin of 97 percent to strike General Motors’ Lordstown, Ohio, plant. Led by young workers and Vietnam veterans, the Lordstown strike was a collective response to rising exploitation. Through a combination of automation and assembly line speedup, the Lordstown plant raised its output from 66 cars per hour in 1966 to over 100 per hour in 1971.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-38",
      "id": "Txt-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" The 29-­year-­old president of the United Auto Workers (UAW) local told author Studs Terkel, “If the guys ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("didn’t stand up and fight, ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("they’d become robots too. ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("They’re interested in being able to smoke a cigarette, bullshit a little bit with the guy next to ’em, open a book, look at something, just daydream if nothing else. You ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("can’t do that if you become a machine.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-39",
      "id": "Txt-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("It was this understanding of class struggle being shaped by material conditions that led socialist historian Hal Draper to argue:")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent-one-para ParaOverride-16"
  }, [_c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v("To engage in class struggle it is not necessary to “believe in” the class struggle any more than it is necessary to believe in Newton in order to fall from an airplane. .")]), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }), _c('span', {
    staticClass: "Indent-text CharOverride-10"
  }, [_vm._v(". The working class moves toward class struggle insofar as capitalism fails to satisfy its economic and social needs and aspirations, not insofar as it is told about struggle by Marxists. There is no evidence that workers like to struggle any more than anyone else; the evidence is that capitalism compels and accustoms them to do so.")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-40",
      "id": "Txt-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Though ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Marcuse’s pessimistic conclusion was wrong, his and similar theories continued to influence the generation of 1960s student radicals, perpetuating the belief that American workers were “bought off” by the system. Indeed, even in the twenty-­first century, many who oppose global injustice frequently mistake the prosperity of U.S. capitalism for the prosperity of its population, despite the gaping inequality within the U.S. population.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Like ")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("­")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Sombart’s, most left-­wing theories of American exceptionalism hold partial truths, but none of the factors they describe has been decisive. There is nothing fundamentally different about the American working class that makes it incapable of acting as a class, or which can explain why workers in the United States have not yet developed an independent political tradition. This was certainly the conclusion drawn by leading Marxists who studied the conditions of the U.S. working class before and after the dawn of the twentieth century. As Mike Davis wrote, “At one time or another, Marx, Engels, Kautsky, Lenin, and Trotsky all became fascinated with the prospects for the development of a revolutionary movement in the United States. Although each emphasized different aspects of contemporary social dynamics, they shared the optimistic belief that ‘in the long run’ the differences between European and American levels of class-­consciousness and political organization would be evened out by objective laws of historical development.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-41",
      "id": "Txt-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("Most Marxists held a balanced view of the strengths and weaknesses of the U.S. working class. Leon Trotsky, who gained a great deal of familiarity with the Depression-­era class struggle in the United States during his final exile in Mexico, reiterated this theme. When asked about the “backwardness” of U.S. workers, he responded, “The backwardness of the United States working class is a relative term. .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". The American worker is very combative—as we have seen during the strikes. They have had the most rebellious strikes in the world. What the American worker misses is a spirit of generalization, or analysis, of his class position in society as a whole.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-42",
      "id": "Txt-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("As Kirk argued, “As seen in the pre-­1914 fortunes of the Socialist Party, there did exist considerable popular support for socialism in America, both inside and (especially) outside the AFL. .")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(". [I]t is not the absence of moves to independent labor and/or socialism which demand explanation, as suggested by proponents of ‘exceptionalism,’ but rather both the frequency and short-­lived character of such moves.")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Text-body CharOverride-14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ch1-FN-43",
      "id": "Txt-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e22bcf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter1.vue
// module id = 90
// module chunks = 0